<template>
  <div>
    <b-modal
      id="addUserModal"
      cancel-variant="default"
      @cancel="closeAddModal()"
      @shown="focusser"
      :no-close-on-backdrop="no_close"
      @ok="addUser"
      ok-title="Létrehozás"
      cancel-title="Mégse"
      :ok-disabled="loading"
      :ok-only="no_close"
    >
      <template slot="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <a v-if="!no_close" class="btn-close" @click="closeAddModal()"></a>
      </template>
      <form
        @submit.prevent="addUser()"
        v-if="
          roles != false &&
          typeof user.role_id != 'undefined' &&
          loading == false
        "
      >
        <div class="form-group">
          <label class="form-label">Vezetéknév</label>
          <input
            ref="add_user_modal_name_input"
            type="text"
            class="form-control mb-2"
            v-model="user.last_name"
            required
            :class="{ 'is-invalid': errors.last_name }"
          />
          <div class="invalid-feedback d-block" v-if="errors.last_name">
            {{ errors.last_name[0] }}
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Keresztnév</label>
          <input
            type="text"
            class="form-control mb-2"
            v-model="user.first_name"
            required
            :class="{ 'is-invalid': errors.first_name }"
          />
          <div class="invalid-feedback d-block" v-if="errors.first_name">
            {{ errors.first_name[0] }}
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Név kiegészítés</label>
          <input
            type="text"
            class="form-control mb-2"
            v-model="user.name_extension"
            :class="{ 'is-invalid': errors.name_extension }"
          />
          <div class="invalid-feedback d-block" v-if="errors.name_extension">
            {{ errors.name_extension[0] }}
          </div>
        </div>
        <div class="form-group" v-if="!no_email">
          <label class="form-label">Email</label
          ><span
            class="text-warning"
            v-if="
              user && roles.find((r) => r.id == user.role_id).can_login == true
            "
            >*kötelező</span
          >
          <div class="input-group mb-2">
            <input
              type="text"
              class="form-control"
              v-model="user.email"
              :required="
                user &&
                roles.find((r) => r.id == user.role_id).can_login == true
              "
              :class="{ 'is-invalid': errors.email }"
            />
            <button
              type="button"
              class="btn btn-default"
              @click="generateEmail"
              title="e-safety email cím generálása"
            >
              <i class="fa-solid fa-wand-magic-sparkles"></i>
            </button>
          </div>
          <div class="invalid-feedback d-block" v-if="errors.email">
            {{ errors.email[0] }}
          </div>
        </div>
        <div
          class="form-group"
          v-if="
            (!partner_id ||
              (authenticated_user &&
                [5, 1].includes(authenticated_user.role_id))) &&
            !cant_choose_role
          "
        >
          <label class="form-label">Jogosultság</label>
          <select
            @change="userUpdate"
            v-model="user.role_id"
            class="form-control mb-2"
            required
            :class="{ 'is-invalid': errors.role_id }"
          >
            <option :value="undefined" disabled>Válassz</option>
            <option
              v-for="(role, id) in filtered_roles"
              :value="role.id"
              :key="id"
              @click="userUpdate"
            >
              {{ role.name }}
            </option>
          </select>
          <div class="invalid-feedback d-block" v-if="errors.role_id">
            {{ errors.role_id[0] }}
          </div>
        </div>
        <div
          class="form-group"
          v-if="!partner_id && [6, 11].includes(user.role_id)"
        >
          <label class="form-label">Partner</label>
          <select
            @change="$forceUpdate(user)"
            v-model="user.partner_id"
            class="form-control mb-2"
            required
            :class="{ 'is-invalid': errors.role_id }"
          >
            <option :value="undefined" disabled>Válassz</option>
            <option
              v-for="(partner, id) in partners"
              :value="partner.id"
              :key="id"
            >
              {{ partner.name }}
            </option>
          </select>
          <div class="invalid-feedback d-block" v-if="errors.partner_id">
            {{ errors.partner_id[0] }}
          </div>
        </div>
        <div class="form-group mt-1">
          <label class="form-label">Terület</label>
          <v-select
            v-if="locationslinear"
            v-model="user.location_id"
            :options="locationslinear"
            :reduce="(option) => option.id"
            label="name"
            multiple
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                v-bind="attributes"
                v-on="events"
                :placeholder="!user.workjob_id ? 'Válassz' : ''"
              />
            </template>
          </v-select>
          <loading mini v-else />
        </div>
        <div class="form-group mt-1">
          <label class="form-label">Munkakör</label>
          <v-select
            v-if="workjobs"
            v-model="user.workjob_id"
            :options="workjobs"
            :reduce="(option) => option.id"
            label="name"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                v-bind="attributes"
                v-on="events"
                :placeholder="!user.workjob_id ? 'Válassz' : ''"
              />
            </template>
          </v-select>
          <loading mini v-else />
        </div>
        <button type="submit" class="d-none"></button>
      </form>
      <Loading v-else-if="loading == false" title="Opciók betöltése"></Loading>
      <Loading v-if="loading == true" title="Létrehozás"></Loading>
    </b-modal>
  </div>
</template>

<script>
import User from "../apis/User";
import Partner from "../apis/Partner";
import Confirmation from "../apis/Confirmation";
/*import Config from "../apis/Config"; */
import Loading from "../components/Loading";
import Workjob from "../apis/Workjob";

export default {
  components: {
    Loading,
  },
  props: [
    "partner_id",
    "title",
    "no_email",
    "no_close",
    "role_id",
    "cant_choose_role",
  ],
  data() {
    return {
      loading: false,
      user: { role_id: 1 },
      email_required: true,
      errors: [],
      roles: false,
      partners: false,
      workjobs: null,
    };
  },
  created() {
    if (this.partner_id) {
      this.user.partner_id = this.partner_id;
    }
    if (this.role_id) {
      this.user.role_id = this.role_id;
    }
    if (!this.partner_id) {
      Partner.index().then((response) => {
        this.partners = response.data;
      });
    }

    /*Config.getConstant('roles')
			.then(response => {
				this.roles = JSON.parse(JSON.stringify(response.data));
			});*/

    Workjob.index().then((response) => {
      this.workjobs = response.data;
    });
    this.roles = JSON.parse(localStorage.getItem("constants")).roles;
  },
  computed: {
    authenticated_user() {
      return this.$store.state.user;
    },
    filtered_roles() {
      if (!this.partner_id) {
        return this.roles;
      } else {
        return this.roles.filter((role) => [11, 6].includes(role.id));
      }
    },
    locationslinear() {
      return this.$store.state.locationslinear;
    },
  },
  watch: {
    "user.role_id": function (val) {
      this.userUpdate();
      if (![6, 11].includes(parseInt(val))) {
        this.user.partner_id = undefined;
      } else {
        this.user.partner_id = this.partner_id;
      }
    },
    partner_id(val) {
      this.user.partner_id = val;
    },
  },
  methods: {
    generateEmail() {
      if (!this.user.last_name || !this.user.first_name) {
        Confirmation.swalErrorMessage(
          "Az email generáláshoz vezetéknév és keresztnév szükséges!"
        );
      } else {
        this.$set(
          this.user,
          "email",
          this.user.last_name
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .concat(
              this.user.first_name
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")[0]
            )
            .concat("@e-safety.hu")
        );
      }
    },
    userUpdate() {
      this.$nextTick(() => {
        this.$forceUpdate(this.user);
      });
    },
    focusser() {
      this.$refs.add_user_modal_name_input.focus();
    },
    preventDefault(bvModalEvt) {
      if (this.no_close && bvModalEvt.trigger == "backdrop") {
        bvModalEvt.preventDefault();
      } else {
        this.closeAddModal();
      }
    },
    closeAddModal() {
      this.user = { role_id: 1 };
      this.errors = [];
      this.$bvModal.hide("addUserModal");
    },
    addUser(bvModalEvt) {
      this.loading = true;
      if (bvModalEvt) {
        //ok gombra van csak event
        bvModalEvt.preventDefault();
      }
      User.add(this.user)
        .then((response) => {
          this.loading = false;
          if (this.users) {
            this.users.unshift(response.data);
          }
          if (response.data.role_id == 11) {
            this.$emit("partner-user-added", response.data);
          } else {
            this.$emit("user-added", response.data);
          }
          this.errors = [];
          this.user = { role_id: 1 };
          this.$bvModal.hide("addUserModal");
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
